import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import backIcon from '../assets/icons/navigate_before.svg';

function DigitalTwin() {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [iframeLink, setIframeLink] = useState('');
  const [headerText, setHeaderText] = useState('Select a Link');
  const navigate = useNavigate();

  useEffect(() => {
    const loadExcelFile = async () => {
      try {
        const response = await fetch('/data/point_clouds.xlsx');
        const data = await response.arrayBuffer();
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet);
        
        const options = parsedData.map(row => ({
          label: row.label,
          link: row.link,
        }));
        setDropdownOptions(options);
      } catch (error) {
        console.error('Error loading Excel file:', error);
      }
    };
    loadExcelFile();
  }, []);

  const handleDropdownChange = (event) => {
    const selectedOption = dropdownOptions.find(
      option => option.label === event.target.value
    );
    if (selectedOption) {
      setIframeLink(selectedOption.link);
      setHeaderText(selectedOption.label);
    } else {
      setHeaderText('Select a Link');
      setIframeLink('');
    }
  };

  const goBack = () => {
    navigate('/landing');
  };

  // New function to open in new tab
  const openInNewTab = () => {
    if (iframeLink) {
      window.open(iframeLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Top Row: Back Button, Title, Dropdown, Open Button */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 20px',
          backgroundColor: '#f5f5f5',
          borderBottom: '1px solid #ccc',
        }}
      >
        <button
          className="back-button"
          onClick={goBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '10px',
            fontSize: '16px',
          }}
        >
          <img
            src={backIcon}
            alt="Back"
            style={{ marginRight: '8px', height: '20px' }}
          />
          Back
        </button>
        
        <h1 style={{ margin: 0, fontSize: '20px', textAlign: 'center' }}>{headerText}</h1>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <select
            className="dropdown-menu"
            onChange={handleDropdownChange}
          >
            <option value="">Select an option</option>
            {dropdownOptions.map((option, index) => (
              <option key={index} value={option.label}>
                {option.label}
              </option>
            ))}
          </select>
          
          {/* New Open in New Tab button */}
          {iframeLink && (
            <button
              onClick={openInNewTab}
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                padding: '8px 12px',
                fontSize: '14px',
              }}
              title="Open in new tab for full functionality"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                style={{ marginRight: '6px' }}
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
              Open in New Tab
            </button>
          )}
        </div>
      </div>

      {/* Bottom Row: Iframe */}
      <div style={{ flexGrow: 1, padding: '20px', height: '87vh' }}>
        {iframeLink ? (
          <iframe
            src={iframeLink}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Dynamic Content"
          />
        ) : (
          <p style={{ textAlign: 'center', color: '#777' }}>Please select an option to load content.</p>
        )}
      </div>
    </div>
  );
}

export default DigitalTwin;